/**
 * **Onde uma mecânica de item pode acontecer.** A CAÇA e o DUELO.
 *
 * ## Porque isto deixou de viver em `jewels.ts` (gate V28H.B)
 *
 * Porque a pergunta nunca foi sobre joias. `JEWEL_EFFECT_MODES` nasceu no
 * catálogo das joias por ser o primeiro subsistema a precisar dela, e ficou lá
 * a chamar-se por um nome que descreve o primeiro consumidor em vez da coisa.
 * As cartas fazem exatamente a mesma pergunta - "esta peça produz efeito na
 * caça?" - e a alternativa a promover isto era uma segunda lista de dois
 * elementos, com um segundo nome, a envelhecer ao lado da primeira.
 *
 * Duas listas com os mesmos dois valores não são duplicação inofensiva: são
 * duas portas por onde um terceiro modo pode entrar em apenas uma.
 *
 * ## O que ela NÃO é
 *
 * Não é a lista de modos que o jogo tem. `PVP_MODES` é sobre recompensa
 * (`no_reward`, `gold_pot`) e `PvpRuleset` é sobre quantas cadeiras
 * (`duel_1v1`, `team_3v3`). Esta é a lista de sítios onde uma mecânica de item
 * pode produzir efeito, e o duelo inteiro é um só sítio: uma peça que vale num
 * 1x1 vale num 3x3.
 *
 * `JEWEL_EFFECT_MODES` e `JewelEffectMode` continuam a existir, aqui
 * reexportados, e são exatamente esta lista e exatamente este tipo.
 */

/** Os dois sítios onde uma mecânica de item pode acontecer. Permanente. */
export const EFFECT_MODES = ['hunt', 'pvp'] as const;
export type EffectMode = (typeof EFFECT_MODES)[number];
